import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const S = {
  List: styled.ul`
    border: solid 1px ${({ theme }) => theme.palette.grey[400]};
    background-color: white;
    padding: 14px 12px;
    min-width: 78px;
    text-align: left;
    li:not(:first-child) {
      color: ${({ theme }) => theme.palette.grey[600]};
    }
  `,
};

const ChartTooltipContent = ({
  active, payload, percentParameter, isValuePercentage,
}) => {
  if (!active) {
    return null;
  }

  return (
    <S.List>
      <li>{payload[0].payload.name}</li>
      <li>
        {
          isValuePercentage
            ? `${payload[0].payload.selectorCount}명`
            : `${payload[0].payload.value}명`
        }
      </li>
      <li>
        {
          isValuePercentage
            ? `${payload[0].payload.value}%`
            : `${((payload[0].payload.value / percentParameter) * 100).toFixed(0)}%`
        }
      </li>
    </S.List>
  );
};

ChartTooltipContent.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.arrayOf(
    PropTypes.object,
  ),
  percentParameter: PropTypes.number.isRequired,
  isValuePercentage: PropTypes.bool,
};

ChartTooltipContent.defaultProps = {
  active: true,
  payload: [],
  isValuePercentage: false,
};

export default ChartTooltipContent;
